import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl bg-opacity-80 bg-blue-200" }, "Reuse Statistics for Authors and Publications", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Loading data ...", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "h-full lg:h-screen"
}
const _hoisted_6 = {
  class: "lg:float-left float-none mt-1.5 w-11/12 lg:w-2/5",
  style: {"height":"85vh","margin-left":"3%"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl" }, "Reuse Statistics by Author", -1)
const _hoisted_8 = {
  class: "lg:float-left float-none mt-20 lg:mt-1.5 w-11/12 lg:w-1/2",
  style: {"height":"85vh","margin-left":"3%"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl" }, "Reuse Statistics by Publication", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_grid_vue = _resolveComponent("ag-grid-vue")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_ag_grid_vue, {
              style: {"width":"100%","height":"97%","margin-top":"3%"},
              class: "ag-theme-alpine",
              columnDefs: _ctx.columns.authors,
              rowData: _ctx.rowData.authors,
              animateRows: true,
              defaultColDef: _ctx.defaultColDef,
              enableCellTextSelection: true
            }, null, 8, ["columnDefs", "rowData", "defaultColDef"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_ag_grid_vue, {
              style: {"width":"100%","height":"97%","margin-top":"2.2%"},
              class: "ag-theme-alpine",
              columnDefs: _ctx.columns.papers,
              rowData: _ctx.rowData.papers,
              animateRows: true,
              defaultColDef: _ctx.defaultColDef,
              enableCellTextSelection: true
            }, null, 8, ["columnDefs", "rowData", "defaultColDef"])
          ]),
          _hoisted_10
        ]))
  ]))
}